import React, { FC, useContext, useState } from 'react';
import { Row, Col } from 'styled-bootstrap-grid';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import CSS from 'csstype';
import { DragDropContext, Draggable, DroppableStateSnapshot, Droppable, DropResult } from '@hello-pangea/dnd';

import { Player } from '../../../../database.schema';
import { UpdateButton } from './update-button';
import { useFetchPlayers } from '../../../api/hooks/use-fetch-players';
import { SelectedIndexContext } from '../../../App';
import { Button } from '../../common-styles/common-styles';

export const NameWrapper = styled.div`
  font-size: 1rem;
  margin: 0.25rem;
  display: flex;
  justify-content: start;
  flex-direction: column;
  input {
    font-size: inherit;
    margin-left: 0.25rem;
    width: 8rem;
  }
`;
const PlayerX = styled.div`
  height: 2rem;
  padding: 5px;
  width: 8rem;
  background: darkgrey;
  text-align: center;
  border: 1px solid grey;
  border-radius: 0.25rem;
  margin: 0.25rem;
`;
const Team1Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 0.25rem;
  width: 100%;
  background-color: red;
  color: white;
  padding: 5px;
  min-height: 2rem;
  display: flex;
  justify-content: center;
`;
const Team2Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 0.25rem;
  width: 100%;
  background-color: blue;
  color: white;
  padding: 5px;
  min-height: 2rem;
  display: flex;
  justify-content: center;
`;
const PlayersWrapper = styled.div`
  border: 1px solid black;
  border-radius: 0.25rem;
  width: 11rem;
  margin: 0.5rem auto;
  background-color: transaparent;
  color: white;
  padding: 5px;
  min-height: 2rem;
`;

const PlayerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 1.25rem;
`;

const style = (snapshot: DroppableStateSnapshot): CSS.Properties => ({
  padding: '0.5rem 1rem',
  minHeight: '4rem',
  background: 'lightcoral',
  borderRadius: '0.25rem',
});

const getPlayersAlphaSort = (players: Array<Player>): Array<Player> => {
  if (players.length) {
    return [...players].sort((a: Player, b: Player) => {
      if (a.nickName < b.nickName) {
        return -1;
      }
      if (a.nickName > b.nickName) {
        return 1;
      }
      return 0;
    });
  }
  return [];
};
export const TeamEntry: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const { isLoading, data } = useFetchPlayers();

  const [players, setPlayers] = useState<Array<Player>>(getPlayersAlphaSort(data as Array<Player>));
  const [team1Name, setTeam1Name] = useState('');
  const [team2Name, setTeam2Name] = useState('');
  const [team1, setTeam1] = useState<Array<Player>>([]);
  const [team2, setTeam2] = useState<Array<Player>>([]);

  if (isLoading) {
    return <div>loading...</div>;
  }
  const isValid = () => {
    return !(team1.length > 3 && team2.length > 3 && team1.length === team2.length);
  };
  const onDragEnd = (result: DropResult): void => {
    if (!result.destination) {
      return;
    }
    if (result.source.droppableId === result.destination.droppableId) {
      return;
    }

    const dragPlayer = players.find((player: Player) => player.id === Number(result.draggableId));
    if (result.destination.droppableId === 'team1') {
      if (dragPlayer) {
        setTeam1([...team1, dragPlayer]);
      }
    }
    if (result.destination.droppableId === 'team2') {
      if (dragPlayer) {
        setTeam2([...team2, dragPlayer]);
      }
    }
    if (result.destination.droppableId === 'players') {
      if (dragPlayer) {
        setPlayers([...players, dragPlayer]);
      }
    }

    if (result.source.droppableId === 'players') {
      const newState = [...players];
      newState.splice(result.source.index, 1);
      setPlayers(newState);
    }
    if (result.source.droppableId === 'team1') {
      const newState = [...team1];
      newState.splice(result.source.index, 1);
      setTeam1(newState);
    }
    if (result.source.droppableId === 'team2') {
      const newState = [...team2];
      newState.splice(result.source.index, 1);
      setTeam2(newState);
    }
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <h1>Create Ryder Cup Teams</h1>
      <h2>Players</h2>
      <Row>
        <PlayersWrapper>
          <Droppable droppableId="players">
            {(provided, snapshot): JSX.Element => (
              <div {...provided.droppableProps} ref={provided.innerRef} style={style(snapshot)}>
                {players.map((player, index) => (
                  <Draggable data-testid={`player-${index}`} key={`state-${player.id}`} draggableId={`${player.id}`} index={index} isDragDisabled={false}>
                    {(provided, snapshot): JSX.Element => (
                      <PlayerX ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        {player.nickName}
                      </PlayerX>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </PlayersWrapper>
      </Row>
      <Row>
        <Col col={6}>
          <div>
            Team Name
            <NameWrapper>
              <input
                type="text"
                autoComplete="off"
                name={'team1Name'}
                id={'team1Name'}
                data-testid={'team1Name'}
                value={team1Name}
                onChange={(e) => {
                  setTeam1Name(e.target.value);
                }}
              />
            </NameWrapper>
          </div>
          <h3>Team</h3>
          <Team1Wrapper>
            <Droppable droppableId="team1" isDropDisabled={team1.length === 5}>
              {(provided, snapshot): JSX.Element => (
                <PlayerContainer {...provided.droppableProps} ref={provided.innerRef} style={{ width: '100%', height: '100%', minHeight: '3rem' }} data-testid="team1-players">
                  {team1.map((player: Player, index) => (
                    <PlayerX key={player.nickName}>{player.nickName}</PlayerX>
                  ))}
                  {provided.placeholder}
                </PlayerContainer>
              )}
            </Droppable>
          </Team1Wrapper>
        </Col>
        <Col col={6}>
          <div>
            Team Name
            <NameWrapper>
              <input
                type="text"
                autoComplete="off"
                name={'team2Name'}
                id={'team2Name'}
                data-testid={'team2Name'}
                value={team2Name}
                onChange={(e) => {
                  setTeam2Name(e.target.value);
                }}
              />
            </NameWrapper>
          </div>
          <h3>Team</h3>
          <Team2Wrapper>
            <Droppable droppableId="team2" isDropDisabled={team2.length === 5}>
              {(provided, snapshot): JSX.Element => (
                <PlayerContainer {...provided.droppableProps} ref={provided.innerRef} style={{ width: '100%', height: '100%', minHeight: '3rem' }} data-testid="team2-players">
                  {team2.map((player: Player, index) => (
                    <PlayerX key={player.nickName}>{player.nickName}</PlayerX>
                  ))}
                  {provided.placeholder}
                </PlayerContainer>
              )}
            </Droppable>
          </Team2Wrapper>
        </Col>
      </Row>
      {updateStatus.error && <div>Update failed!!!!</div>}
      <ButtonWrapper>
        <UpdateButton
          selectedTournamentIndex={selectedTournamentIndex}
          team1Name={team1Name}
          team1={team1}
          team2Name={team2Name}
          team2={team2}
          onSuccess={() => navigate('/')}
          setUpdateStatus={setUpdateStatus}
          disabled={isValid()}
        />
        <Button onClick={() => navigate('/')}>Cancel</Button>
      </ButtonWrapper>
    </DragDropContext>
  );
};
